// extracted by mini-css-extract-plugin
export default {"tasksWidget":"agcwC","componentContainer":"ioZjh","errorContainer":"MoBGU","rotateOut":"BK6dF","rotateIn":"ipG6h"};